export default function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-hierarchy/src/hierarchy/ancestors.js
// module id = 1076
// module chunks = 0